export default __webpack_public_path__ + "static/media/4.bf14cb84.jpg";